export enum OfferTypeEnum {
  In = 1,
  Out,
}
